import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function WalletInput({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M2.99609 6.99789H19.0028C20.1078 6.99789 21.0036 7.8937 21.0036 8.99873V18.5027C21.0036 19.884 19.8838 21.0037 18.5026 21.0037H13.0003M17.0019 6.99789V5.99748C17.0019 4.89245 16.1061 3.99664 15.0011 3.99664H5.49714C4.11585 3.99664 2.99609 5.1164 2.99609 6.49768V15.0012M9.99901 19.0029H2.99609M9.99901 19.0029L7.99818 21.0037M9.99901 19.0029L7.99818 17.0021M17.0012 14.0008H16.0012" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default WalletInput;